/**
 * Page titles used across the application UI and testing
 * Centralized to ensure consistency between UI components and E2E tests
 */

export const PAGE_TITLES = {
  /** Client app main page titles */
  CLIENT: {
    COURSES: 'Courses',
    CALENDAR: 'Calendar',
    LIVE_EVENTS: 'Live Events',
    RECORDED_EVENTS: 'Recorded Events',
    TOOLS_TEMPLATES: 'Tools & Templates',
    DEALS_DISCOUNTS: 'Deals & Discounts',
  },

  /** Settings page titles */
  SETTINGS: {
    AVAILABILITY: 'Availability Settings',
    SECURITY: 'Security',
    BILLING: 'Billing',
    NOTIFICATIONS: 'Updates and Alerts',
    INTEGRATIONS: 'Integrations',
    MY_MBA: 'My MBA',
    MANAGE_ACCOUNT: 'Manage Account',
  },

  /** Partner app page titles */
  PARTNER: {
    MEMBERS: 'Members',
    COHORTS: 'Cohorts',
    SETTINGS: 'Partner Settings',
    BILLING: 'Billing',
  },

  /** Admin app page titles */
  ADMIN: {
    DASHBOARD: 'Welcome to the Admin Dashboard',
    COURSES: 'Courses',
    EVENTS: 'Events',
    VIDEOS: 'Videos',
    MENTORS: 'Mentors',
    SCENARIOS: 'Scenarios',
    TOOLS_TEMPLATES: 'Tools & Templates',
    DEALS_DISCOUNTS: 'Deals & Discounts',
    ROLES_PERMISSIONS: 'Roles & Permissions',
    COMPANIES: 'Companies',
    PARTNERS: 'Partners',
    FEATURE_FLAGS: 'Feature Flags',
    CERTIFICATES: 'Certificates',
    MBA_OPERATIONS: 'MBA Operations',
    PAYMENT_DISPUTES: 'Payment Disputes',
    MEETING_REFUND_JOBS: 'Meeting Refunds',
  },
} as const;
